import React, { useEffect, useState } from "react";
import ModelWord1 from "../TableModel/Word/ModelWord1";
import ModelWord2 from "../TableModel/Word/ModelWord2";
import ModelWord3 from "../TableModel/Word/ModelWord3";
import useFormsFormulaStore from "../../../store/zustandStore/formsFormulaZs";
import { APP_URL } from "../../../services/http-common";
import authHeader from "../../../services/auth-header";
import axios from "axios";
import { Paragraph, TextRun } from "docx";
import ParagraphPrint from "../PrintWord/ParagraphPrint";
import ModelWorldReklmaSekonda from "../TableModel/Word/ModelWorldReklmaSekonda";
import ModelWordTextDotValue from "../TableModel/Word/ModelWordTextDotValue";
import ModelWorldShareholding from "../TableModel/Word/ModelWorldShareholding";
import { ModelWorldProgramList } from "../TableModel/Word/ModelWorldProgramList";
import { ModelWorldPopullata } from "../TableModel/Word/ModelWorldPopullata";
import { ModelWorldShtojca1 } from "../TableModel/Word/ModelWorldShtojca1";
import { ModelWordListOshma } from "../TableModel/Word/ModelWordListOshma";
import { ModelWorldReklamaBleresit } from "../TableModel/Word/ModelWorldReklamaBleresit";
import { ModelWorldVleresimGjinor1 } from "../TableModel/Word/ModelWorldVleresimGjinor1";
import { ModelWorldVleresimGjinor2 } from "../TableModel/Word/ModelWorldVleresimGjinor2";
import { ModelWorldShtojca2 } from "../TableModel/Word/ModelWorldShtojca2";
import { ModelWorldShtojca3 } from "../TableModel/Word/ModelWorldShtojca3";
import { ModelWorldShtojca4 } from "../TableModel/Word/ModelWorldShtojca4";

export const TableSwitchPrint = async (data, customHeader, customFooter) => {
  const { formulaId, year, postProcessing, formFormulaType, apiEndpoint } =
    data;
  const URLEntityName = APP_URL + "forms-formula";

  let dataFromApi = [];

  const getData = async () => {
    if (formFormulaType === "API") {
      try {
        const response = await axios.get(APP_URL + apiEndpoint, {
          headers: authHeader(),
        });

        if (
          postProcessing &&
          postProcessing !== "string" &&
          postProcessing !== null &&
          postProcessing !== undefined &&
          postProcessing !== ""
        ) {
          let groupByType;
          try {
            groupByType = eval(`(${postProcessing})`);
            dataFromApi = response.data;
            return groupByType(response.data);
            // return groupByType(response.data) ?? {};
          } catch (err) {
            console.error("Eval failed:", err);
            return err; // stop execution
          }
        }

        if (response?.all) {
          dataFromApi = response.all;
          // return response?.data?.all;
        } else if (response?.data?.content) {
          dataFromApi = response.data.content;
          // return response?.data?.all;
        } else if (response?.content) {
          dataFromApi = response.content;
          // return response?.data?.all;
        } else {
          if (response?.data) {
            dataFromApi = response.data;
            // return response?.data;
          } else {
            dataFromApi = response;
            // return response;
          }
        }
        return response?.data?.content;
      } catch (error) {
        console.error("Error fetching items", error);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    } else {
      if (formulaId !== "" && formulaId !== undefined) {
        try {
          const selected = { formulaId: formulaId, year: year };

          const response = await axios.post(
            URLEntityName + "/evaluate",
            selected,
            {
              headers: authHeader(),
            }
          );
          if (response?.all) {
            dataFromApi = response.all;
            // return response?.data?.all;
          } else if (response?.data?.all) {
            dataFromApi = response.data.all;
            // return response?.data?.all;
          } else {
            if (response?.data) {
              dataFromApi = response.data;
              // return response?.data;
            } else {
              dataFromApi = response;
              // return response;
            }
          }
        } catch (error) {
          console.error("Gabim gjatë marrjes së të dhënave:", error);
        }
      }
    }
  };

  const repsonseDta = await getData();

  const dataTest = { ...data, tableContent: dataFromApi };

  switch (data.tableSetting?.model?.id) {
    case "model-1":
      return [...ModelWord1(data, customHeader, customFooter)];
    case "model-2":
      return [...ModelWord2(data, customHeader, customFooter)];
    case "model-3":
      return [...ModelWord3(dataTest, customHeader, customFooter)];
    case "model-reklama-sekonda":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldReklmaSekonda(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-text-dot-value":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWordTextDotValue(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-shareholding":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldShareholding(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-program-list":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldProgramList(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }

    case "model-popullata":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldPopullata(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-shtojca-1":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldShtojca1(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-shtojca-2":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldShtojca2(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-shtojca-3":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldShtojca3(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-shtojca-4":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldShtojca4(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-list-oshma":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWordListOshma(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-reklama-bleresit":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldReklamaBleresit(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-vleresim-gjinor-1":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldVleresimGjinor1(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }
    case "model-vleresim-gjinor-2":
      if (dataFromApi !== undefined && dataFromApi !== null) {
        return [...ModelWorldVleresimGjinor2(dataFromApi)];
      } else {
        return new Paragraph({ children: [new TextRun("bosh")] });
      }

    default:
      return new Paragraph({ children: [new TextRun("bosh")] });
  }
};
